// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__nLZfK","logo":"style_logo__sTvG_"};